// The one import path. Components import from '../i18n', never a file inside
// it, so the module's shape stays free to change.
export { LocaleProvider, useT, useLocale } from './LocaleProvider';
export { LOCALES, DEFAULT_LOCALE, LOCALE_KEY } from './locales';
export { translate } from './translate';
